module.exports = __webpack_public_path__ + "e0315853a2794045c81bfb0c69598353.svg";